import { render, staticRenderFns } from "./InputBox.vue?vue&type=template&id=76a0d0a9&"
import script from "./InputBox.vue?vue&type=script&lang=js&"
export * from "./InputBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports